module.exports = __webpack_public_path__ + "img/lose.7e3be6d0.png";